import { Component } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import {
  IComplaintsDashboardView,
  IDashboardKpi,
} from '../../../../../core/interfaces/complaints-dashboard.interface';
import { ComplaintsDashboardStore } from '../../complaints-dashboard.store';

@Component({
  selector: 'app-dashboard-kpis',
  templateUrl: './dashboard-kpis.component.html',
  styleUrls: ['./dashboard-kpis.component.scss'],
})
export class DashboardKpisComponent {
  kpis$: Observable<IDashboardKpi[]>;

  constructor(private store: ComplaintsDashboardStore) {
    this.kpis$ = this.store.view$.map((view: IComplaintsDashboardView) =>
      view ? view.kpis : [],
    );
  }

  trackByLabel(index: number, item: IDashboardKpi) {
    return item.label;
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/complaints/complaints-dashboard/components/dashboard-kpis/dashboard-kpis.component.ts